import styles from './index.module.scss';
import CircleArrow from './svg';

interface CircleArrowButtonProps {
  onClick: () => void;
  direction: 'left' | 'right';
  className?: string;
}

const CircleArrowButton = ({ onClick, direction, className }: CircleArrowButtonProps) => {
  return (
    <div
      className={[styles['button'], styles[`button-${direction}`], className].join(' ')}
      onClick={onClick}
      aria-label={direction === 'left' ? '上一张' : '下一张'}
    >
      <CircleArrow />
    </div>
  );
};

export default CircleArrowButton;
